module.exports = __webpack_public_path__ + "static/media/editTable.92211dc9.svg";